import { render, staticRenderFns } from "./BulletinList.vue?vue&type=template&id=6cedd468"
import script from "./BulletinList.vue?vue&type=script&lang=js"
export * from "./BulletinList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports